import React, {useEffect} from "react";
import {XMarkIcon} from '@heroicons/react/20/solid'
import QrReader from "../qr/reader/QrReader";
import {useNavigate} from "react-router-dom";
import {ADMIN_ROLE, getLoginSession, SELL_ROLE} from "../../requests/AppSession";

export default function VTRevertSellQRReader({setIsQRReader, setShowRevertQRReader, submitRevertVT, revertAmount}) {
    let navigate = useNavigate();

    useEffect(() => {
        getLoginSession().then(loginSession => {
            if (loginSession && loginSession.userId) {
                if (loginSession.roles) {
                    const checkRoles = loginSession.roles.split(",");
                    if (checkRoles && (!checkRoles.includes(ADMIN_ROLE) && !checkRoles.includes(SELL_ROLE))) {
                        navigate('/', {replace: true});
                    }
                }
            } else {
                navigate('/login/mobile', {replace: true});
            }
        })

        return function cleanup() {

        };
    }, []);

    return (
        <>
            <div className="flex items-center gap-x-6 bg-pink-600 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
                <p className="text-sm leading-6 text-white">
                    <a href="#">
                        <strong className="font-semibold">Revert VirtualTipz</strong>
                        <svg viewBox="0 0 2 2" className="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
                            <circle cx={1} cy={1} r={1}/>
                        </svg>
                        {revertAmount}&nbsp;
                        {/*<span aria-hidden="true">&rarr;</span>*/}
                    </a>
                </p>
                <div className="flex flex-1 justify-end">
                    <button
                        type="button"
                        className="-m-3 p-3 focus-visible:outline-offset-[-4px]"
                        onClick={() => {
                            //navigate('/sell');
                            setShowRevertQRReader(false);
                        }}
                    >
                        <span className="sr-only">Dismiss</span>
                        <XMarkIcon className="h-5 w-5 text-white" aria-hidden="true"/>
                    </button>
                </div>
            </div>
            <QrReader setIsQRReader={setIsQRReader} submitVT={submitRevertVT} selectedSize={null} setShowQRReader={setShowRevertQRReader}/>
        </>
    )
}
